import _objectWithoutProperties from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["render"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import CdnPath from '../../utils/cdnPath';
import { enterOfferView } from '../../state/actions/rewardCenter';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});
var DISABLED_FILTER = -1;
var OFFER_LIST_SORT_TYPES = {
  LOYALTY_POINTS_ASCENDING: 'lpts_asc',
  LOYALTY_POINTS_DESCENDING: 'lpts_desc',
  REWARD_NAME_ASCENDING: 'rname_asc',
  END_TIME_ASCENDING: 'endtime_asc',
  END_TIME_DESCENDING: 'endtime_desc',
  REMAINING_REDEEMS_ASCENDING: 'remainingredeems_asc',
  REMAINING_REDEEMS_DESCENDING: 'remainingredeems_desc'
};

var OfferList = /*#__PURE__*/function (_Component) {
  _inherits(OfferList, _Component);

  var _super = _createSuper(OfferList);

  function OfferList() {
    var _this;

    _classCallCheck(this, OfferList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      shouldRender: false
    };

    _this.applyOfferFilters = function (offers) {
      return offers.filter(function (offer) {
        if (_this.props.activeFilter) {
          if (_this.props.activeFilter !== DISABLED_FILTER && offer.rc_id != _this.props.activeFilter) {
            return false;
          }
        }

        if (_this.props.activeProperty) {
          if (_this.props.activeProperty !== DISABLED_FILTER && offer.propertyId != _this.props.activeProperty) {
            return false;
          }
        }

        return true;
      });
    };

    _this.getSortHandler = function (ruleName) {
      var handleEndTimeEdgeCases = function handleEndTimeEdgeCases(a, b) {
        if (!a.endtime && !b.endtime) {
          return 0;
        }

        if (!a.endtime) {
          return 1;
        }

        if (!b.endtime) {
          return -1;
        }

        return null;
      };

      switch (ruleName) {
        case OFFER_LIST_SORT_TYPES.LOYALTY_POINTS_ASCENDING:
          return function (a, b) {
            return a.lpts - b.lpts;
          };

        case OFFER_LIST_SORT_TYPES.LOYALTY_POINTS_DESCENDING:
          return function (a, b) {
            return b.lpts - a.lpts;
          };

        case OFFER_LIST_SORT_TYPES.REWARD_NAME_ASCENDING:
          return function (a, b) {
            if (a.rname < b.rname) {
              return -1;
            }

            if (a.rname > b.rname) {
              return 1;
            }

            return 0;
          };

        case OFFER_LIST_SORT_TYPES.END_TIME_ASCENDING:
          return function (a, b) {
            var edge = handleEndTimeEdgeCases(a, b);

            if (edge !== null) {
              return edge;
            }

            return a.endtime - b.endtime;
          };

        case OFFER_LIST_SORT_TYPES.END_TIME_DESCENDING:
          return function (a, b) {
            var edge = handleEndTimeEdgeCases(a, b);

            if (edge !== null) {
              return edge;
            }

            return b.endtime - a.endtime;
          };

        case OFFER_LIST_SORT_TYPES.REMAINING_REDEEMS_ASCENDING:
          return function (a, b) {
            return a.remainingredeems - b.remainingredeems;
          };

        case OFFER_LIST_SORT_TYPES.REMAINING_REDEEMS_DESCENDING:
          return function (a, b) {
            return b.remainingredeems - a.remainingredeems;
          };

        default:
          return function () {
            console.warn("Undefined OFFER_LIST_SORT_TYPES: '".concat(ruleName, "'"));
          };
      }
    };

    _this.handleOrdering = function (offers) {
      return offers.sort(function (a, b) {
        var _iterator = _createForOfIteratorHelper(_this.props.api.core.sortingRules),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var sortRule = _step.value;

            var result = _this.getSortHandler(sortRule.name)(a, b);

            if (result !== 0) {
              return result;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return 0;
      });
    };

    _this.prepareForRender = function (offers) {
      var formattedOffers = [];

      var _iterator2 = _createForOfIteratorHelper(offers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var offer = _step2.value;
          formattedOffers.push(_objectSpread(_objectSpread({}, offer), {}, {
            lpts: format(offer.lpts)
          }));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return formattedOffers;
    };

    _this.formatOffers = function (offers) {
      offers = _this.applyOfferFilters(offers);
      offers = _this.handleOrdering(offers);
      offers = _this.prepareForRender(offers);
      return offers;
    };

    return _this;
  }

  _createClass(OfferList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.prepareRender();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.prepareRender();
    }
  }, {
    key: "prepareRender",
    value: function () {
      var _prepareRender = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator3, _step3, item, _iterator4, _step4, _item;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.state.shouldRender && this.props.api.core.filterList.length > 0)) {
                  _context.next = 36;
                  break;
                }

                _iterator3 = _createForOfIteratorHelper(this.props.api.core.filterList);
                _context.prev = 2;

                _iterator3.s();

              case 4:
                if ((_step3 = _iterator3.n()).done) {
                  _context.next = 10;
                  break;
                }

                item = _step3.value;
                _context.next = 8;
                return this.props.preload("".concat(this.props.rewardCenterBaseUrl).concat(item.title_image));

              case 8:
                _context.next = 4;
                break;

              case 10:
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);

                _iterator3.e(_context.t0);

              case 15:
                _context.prev = 15;

                _iterator3.f();

                return _context.finish(15);

              case 18:
                _iterator4 = _createForOfIteratorHelper(this.props.api.core.offers);
                _context.prev = 19;

                _iterator4.s();

              case 21:
                if ((_step4 = _iterator4.n()).done) {
                  _context.next = 27;
                  break;
                }

                _item = _step4.value;
                _context.next = 25;
                return this.props.preload("".concat(_item.thumb));

              case 25:
                _context.next = 21;
                break;

              case 27:
                _context.next = 32;
                break;

              case 29:
                _context.prev = 29;
                _context.t1 = _context["catch"](19);

                _iterator4.e(_context.t1);

              case 32:
                _context.prev = 32;

                _iterator4.f();

                return _context.finish(32);

              case 35:
                this.setState({
                  shouldRender: true
                });

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 12, 15, 18], [19, 29, 32, 35]]);
      }));

      function prepareRender() {
        return _prepareRender.apply(this, arguments);
      }

      return prepareRender;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          additionalProps = _objectWithoutProperties(_this$props, _excluded);

      var offers = this.formatOffers(this.props.api.core.offers);
      return render(_objectSpread(_objectSpread({}, additionalProps), {}, {
        offers: offers,
        activeFilter: this.props.activeFilter,
        activeProperty: this.props.activeProperty,
        defaultOfferThumbnail: "".concat(CdnPath.REWARD_CENTER_OFFERS_UI, "default_reward_tile.jpg"),
        defaultAvailableOfferThumbnail: "".concat(CdnPath.REWARD_CENTER_THUMBNAILS, "Rewards_Center_Frame@3x.jpg"),
        shouldRender: this.state.shouldRender
      }));
    }
  }]);

  return OfferList;
}(Component);

export default connect(function (state) {
  return _objectSpread(_objectSpread({}, state.rewardCenter), {}, {
    onboardingStep: state.currentOnboarding.currentStep
  });
}, function (dispatch) {
  return {
    onActivateOfferTile: function onActivateOfferTile(id) {
      return function (event) {
        // TODO: generically memoize event handler
        dispatch(enterOfferView(id));
      };
    }
  };
})(OfferList);